import { type FC } from 'react'

import { Button } from '@/components/ui/button'
import { setMessageIdToFetch } from '@/models/chattingUI/messages/messages.ts'
import { useOpenChat } from '@/modules/chatting/hooks/use-open-chat'

interface Props {
  onlyfansFanId: number
  onlyfansMessageId: number
}

export const ChatMessageLink: FC<Props> = ({
  onlyfansFanId,
  onlyfansMessageId,
}) => {
  const { handleOpenChat } = useOpenChat()

  const handleClick = () => {
    handleOpenChat(onlyfansFanId)
    // Trigger scroll to the message
    // we need to reset it for a case when we jump a second time to the same message after scrolling
    setMessageIdToFetch(null)
    // Ensure that the message id is not cleared on chat change
    setTimeout(
      () =>
        setMessageIdToFetch({
          fanId: onlyfansFanId,
          messageIdToFetch: onlyfansMessageId,
        }),
      0,
    )
  }

  return (
    <Button
      variant="ghost"
      onClick={handleClick}
    >
      Open
    </Button>
  )
}
